import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import { Taxonomy } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { DEFAULT_LANGUAGE } from '../../../config/constants';
import { ParagraphTargetAudiencesHighlighted as Type } from '../custom';

export interface ParagraphTargetAudiencesHighlightedProps {
  entity: ImmutableEntity<Type>;
  className?: string;
}

// eslint-disable-next-line max-len
const ParagraphTargetAudiencesHighlighted: React.FC<ParagraphTargetAudiencesHighlightedProps> = (props) => {
  const { entity, className } = props;

  const classNames = c('ParagraphTargetAudiencesHighlighted', className);
  const paragraph = entity.toJS();
  const uuid = paragraph.uuid[0].value;
  const title = paragraph.field_title[0]?.value;
  const targetAudiences = paragraph.field_target_audiences;

  return (
    <div id={uuid} className={classNames}>
      {title && (
        <h2>{title}</h2>
      )}

      <Container>
        <div className="u-flex u-flex-wrap u-flex-nowrap--lg u-gap--row--6 u-gap--row--lg--10 u-gap--column--5 u-gap--column--lg--10">
          {targetAudiences.map((targetAudience) => {
            const id = targetAudience.target_id;
            const language = targetAudience.entity?.langcode[0].value || DEFAULT_LANGUAGE;

            return (
              <div className="w-100" key={`taxonomy:${id}:${language}`}>
                <Taxonomy
                  className="h-100"
                  entity={Immutable.fromJS(targetAudience.entity)}
                  viewMode="teaser"
                  aboveTheFold
                />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default ParagraphTargetAudiencesHighlighted;
